import axios from '../common/CommonConfigRestService'

const baseUserUrl = '/user'

export default {
  getUsers () {
    return axios.get('/security/users', { params: { size: 100 } }).then(response => response.data.items)
  },
  getRoles () {
    return axios.get('/security/roles/assignable').then(response => response.data)
  },
  saveUser (userInfo) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: baseUserUrl + '/save',
        data: {
          id: userInfo.id,
          username: userInfo.username,
          password: userInfo.password,
          passwordConfirmation: userInfo.passwordConfirmation,
          roleIds: userInfo.roleIds,
          version: userInfo.version,
          reason: userInfo.reason,
          company: userInfo.company
        }
      }).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateMetadata (userInfo) {
    return axios.post(baseUserUrl + '/save', {
      id: userInfo.id,
      username: userInfo.username,
      version: userInfo.version,
      reason: userInfo.reason,
      company: userInfo.company
    }).then(response => response.data)
  },
  roleImpact (id, input) {
    return axios.post(`/security/users/${id}/roles/impact`, input).then(response => response.data)
  },
  replaceRoles (id, input) {
    return axios.put(`/security/users/${id}/roles`, input).then(response => response.data)
  },
  effectivePermissions (id) {
    return axios.get(`/security/users/${id}/permissions`).then(response => response.data)
  },
  changeActive (id, input) {
    return axios.patch(`/security/users/${id}/active`, input).then(response => response.data)
  },
  resetPassword (id, input) {
    return axios.put(`/security/users/${id}/password`, input).then(response => response.data)
  },
  disableUser (user) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: baseUserUrl + '/disableUser',
        data: {id: user.id, version: user.version, reason: user.reason || 'Baja solicitada desde Usuarios'}
      }).then((response) => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
